module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DC79_1SD_HZK.b8db9ff5.jpg";